import { selectUserConnected } from "@/store/reducers/user/user.selector";
import { connect, ConnectedProps } from "react-redux";
import { useRoutes } from "react-router-dom";
import { publicRoutes } from "./public.routes";
import { createStructuredSelector } from "reselect";
import { setAuthToken } from "@/utils/setAuthToken";
import { protectedRoutes } from "./protected.routes";

type PropsFromRedux = ConnectedProps<typeof connector>;

const AppRoutesFct: React.FC<PropsFromRedux> = ({userConnected}) => {
  const routes = userConnected?.token ? protectedRoutes : publicRoutes;

  setAuthToken(userConnected?.token);

  const element = useRoutes([...routes]);

  return <>{element}</>;
};

const mapStateToProps = createStructuredSelector({
  userConnected : selectUserConnected
});

const connector = connect(mapStateToProps);

const AppRoutes = connector(AppRoutesFct);

export default AppRoutes;
